import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=48a498cc&"
import script from "./PaymentPix.vue?vue&type=script&lang=js&"
export * from "./PaymentPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a498cc')) {
      api.createRecord('48a498cc', component.options)
    } else {
      api.reload('48a498cc', component.options)
    }
    module.hot.accept("./PaymentPix.vue?vue&type=template&id=48a498cc&", function () {
      api.rerender('48a498cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentData/PaymentPix.vue"
export default component.exports